import { useCoach } from "@/lib/states/session/hooks";
import {
  DEFAULT_WEEK_STARTS_ON,
  asWeekStartsOn,
  type WeekStartsOn,
} from "./weekStart";

export function useWeekStartsOn(): WeekStartsOn {
  const coach = useCoach();
  return asWeekStartsOn(coach?.weekStartsOn ?? DEFAULT_WEEK_STARTS_ON);
}
